<template>
  <SList v-if="lessons">
    <SListItem
      v-for="(lesson, i) in lessons"
      :key="i"
      :data-cy="lesson.meta.shortname"
      :aria-pressed="lesson.isSelected ? 'true' : 'false'"
      @click="$emit('toggle', lesson.id)"
    >
      <template #icon>
        <classbook-entity-item-display selected-entity="courses" :entity="lesson" />
      </template>

      <template #right-action>
        <SCheckbox
          v-model="lesson.isSelected"
          checkbox-type="round"
          :name="`lesson-selected-${lesson.id}`"
          :label-text="lesson.meta.shortname"
        ></SCheckbox>
      </template>
    </SListItem>
  </SList>
</template>
<script>
import ClassbookEntityItemDisplay from 'src/components/classbook/ClassbookEntityItemDisplay.vue'
import SCheckbox from 'src/components/base/SCheckbox.vue'

export default {
  name: 'CourseSelectionMenu',
  components: { ClassbookEntityItemDisplay, SCheckbox },
  props: {
    lessons: {
      type: [Object, Array],
      required: true,
    },
  },

  emits: ['toggle'],
}
</script>
